'use strict';

var Joi = require('joi');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var GadgetUserLogin = Joi__default["default"].object().keys({
  email: Joi__default["default"].string().email({
    tlds: {
      allow: false
    }
  }).allow(null).description('End user email'),
  phone: Joi__default["default"].string().allow(null).optional().description('End user phone number if they authed with SMS'),
  new_account: Joi__default["default"].boolean().required().description('Is user logging in for very first time'),
  paying: Joi__default["default"].boolean().required().description('Is user a paying customer'),
  has_password: Joi__default["default"].boolean().required().description('Is the user logging in with a password?'),
  otp_verified: Joi__default["default"].boolean().required().description('Is the user logging in via OTP?')
}).description('This event fires when a user authenticates. This can be through email or phone, as well as using a social account to OAuath with.').meta({
  name: 'GadgetUserLogin',
  filename: 'gadget:user_login.model'
});
var GadgetUserLogin$1 = GadgetUserLogin;

module.exports = GadgetUserLogin$1;
//# sourceMappingURL=user_login.model.js.map
